import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'Label';
const Label = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, note, className, noteClassName } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: cx('Label', className)
    }, children, note ? /*#__PURE__*/ React.createElement("div", {
        className: cx('Label-note', noteClassName)
    }, note) : null);
};
Label.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    note: PropTypes.node,
    noteClassName: PropTypes.string
};
export default Label;
